import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SessionGuard from './common/session-guard';
import './index.css';
import Login from './login/login';
import reportWebVitals from './reportWebVitals';
import ResetPassword from './password-reset/password-reset';
import PostLoginMenu from './post-login-menu/post-login-menu';
import Application from './menu/application';
import Release from './login/release';
import AccountAdminMenu from './menu/account-admin';
import FacesAdminMenu from './menu/faces-admin';
import NewPassword from './new-password/new-password';
import LoginPage from './login-page/login-page';
import ConfirmPasswordReset from './confirm-password-reset/confirm-password-reset';
import AccountEdit from './faces-admin/account-edit';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <Routes>
      {/* Login-related routes */}
      <Route
        path="login"
        element={
          <LoginPage>
            <Login />
          </LoginPage>
        }
      />
      <Route
        path="new-password"
        element={
          <LoginPage>
            <NewPassword />
          </LoginPage>
        }
      />
      <Route
        path="reset-password"
        element={
          <LoginPage>
            <ResetPassword />
          </LoginPage>
        }
      />
      <Route
        path="reset-password/confirm"
        element={
          <LoginPage>
            <ConfirmPasswordReset />
          </LoginPage>
        }
      />

      {/* Authenticated routes */}
      <Route
        path="*"
        element={
          <SessionGuard>
            <Routes>
              <Route path="menu" element={<PostLoginMenu />} />
              <Route path="release" element={<Release />} />
              <Route path="menu/application" element={<Application />} />
              <Route path="menu/admin" element={<AccountAdminMenu />} />
              <Route path="menu/faces" element={<FacesAdminMenu />} />
              <Route path="menu/faces/editaccount" element={<AccountEdit />} />
              <Route path="/" element={<Navigate to="/login" replace />} />
            </Routes>
          </SessionGuard>
        }
      />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
